export default __webpack_public_path__ + "static/media/downloadAndroid.6c669825.webp";